export default {
  'ru-ru': {
    shop_name_form: {
      plural: {
        D: 'магазинам',
        I: 'магазины',
        P: 'магазинах',
        R: 'магазинов',
        T: 'магазинами',
        V: 'магазины'
      },
      singular: {
        D: 'магазину',
        I: 'магазин',
        P: 'магазине',
        R: 'магазина',
        T: 'магазином',
        V: 'магазин'
      }
    }
  }
};